<template>
  <Card>
    <AjaxForm v-if="req" :route="'admin/requestSpecialAccount/Edit/'+req._id" :callback="editCallback">
      <div class="row">
        <div class="col-12 col-md-4 mb-2">
          <label>درخواست دهنده : </label>
         &nbsp;<span v-if="req.user_id">{{req.user_id.title}}({{req.user_id.phone}}) </span>
        </div>
        <div class="col-12 col-md-4 mb-2">
          <label>تاریخ درخواست : </label>
          &nbsp;<span>{{req.date}}</span>
        </div>
        <div class="col-12 col-md-4 mb-2">
          <label>وضعیت فعلی : </label>
          <span v-html="req.status_label"></span>
        </div>
        <div class="col-12 col-md-4 mb-2">
          <label>نام معرف اول : </label>
          <span>{{req.introducer_name1}}</span>
        </div>
        <div class="col-12 col-md-4 mb-2">
          <label>تلفن معرف اول : </label>
          <span>{{req.introducer_phone1}}</span>
        </div>
        <div class="col-12 col-md-4 mb-2">
          <label>آدرس فروشگاه معرف اول : </label>
          <span>{{req.introducer_shop_address1}}</span>
        </div>
        <div class="col-12 col-md-4 mb-2">
          <label>نام معرف دوم : </label>
          <span>{{req.introducer_name2}}</span>
        </div>
        <div class="col-12 col-md-4 mb-2">
          <label>تلفن معرف دوم : </label>
          <span>{{req.introducer_phone2}}</span>
        </div>
        <div class="col-12 col-md-4 mb-2">
          <label>آدرس فروشگاه معرف دوم : </label>
          <span>{{req.introducer_shop_address2}}</span>
        </div>
        <div class="col-12 col-md-4 mb-2">
          <label>لینک گزارش سامانه آیس: </label>
          <span>{{req.ices_link}}</span>
        </div>
        <div class="col-12 col-md-4 mb-2">
          <label>آخرین ویرایش توسط :  </label>
          <div v-if="req.last_edit_user_id">
            <div>{{req.last_edit_user_id.fullname}}</div>
            <div>{{req.edit_date}}</div>
          </div>
          <span v-else>--</span>
        </div>
      </div>
      <div class="pics-div">
        <a :href="prefix+req.national_pic_name" target="_blank" class="img-div">
          <label>کارت ملی  </label>
          <img class="pic" :src="prefix+req.national_pic_name" alt=""/>
        </a>
        <a :href="prefix+req.javaz_kasb_pic_name" target="_blank" class="img-div">
          <label>جواز کسب</label>
          <img class="pic" :src="prefix+req.javaz_kasb_pic_name" alt=""/>
        </a>
        <a :href="prefix+req.shop_pic_name" target="_blank" class="img-div">
          <label>تصویر فروشگاه </label>
          <img class="pic" :src="prefix+req.shop_pic_name" alt=""/>
        </a>
      </div>
      <hr/>
      <div v-if="req.status !== 'expired'" class="row">
        <div class="col-12 col-md-4 mb-2">
          <custom-input type="select"
                        :not-select-append-to-body="!!request_id"
                        :select-options="status_options"
                        v-model="status"
                        name="status"
                        reduce_select="value"
                        placeholder="انتخاب وضعیت"
                        select-label="title" label="وضعیت"></custom-input>
        </div>
        <div  class="col-12 col-md-4 mb-2">
          <custom-input type="date" v-model="req.credit_date" name="credit_date" placeholder="معتبر تا" label="تاریخ اعتبار"></custom-input>
        </div>
        <div class="col-12">
          <label>دلیل رد</label>
          <input type="hidden" name="deny_reason" readonly hidden v-model="req.deny_reason">
          <editor v-model="req.deny_reason" api-key="f60dl4sz819mfm6cps7g9825ms3y9brgz2hlbiwc610e2mbd"
                  :init="{
                     language: 'fa',
                     directionality : 'rtl',
                     menubar: false,
                     plugins: 'lists',
                     toolbar:
                     'undo redo | formatselect | bold italic backcolor | \
                     alignright aligncenter alignleft alignjustify | \
                     bullist numlist outdent indent  | removeformat'}"
          ></editor>
        </div>
      </div>
      <div v-if="req.status !== 'expired'" class="row">
        <div class="col-12 col-md-5 mb-2 d-grid align-self-center mx-auto my-2">
          <button type="submit" class="btn btn-info btn-block">ویرایش درخواست</button>
        </div>
      </div>
      <div class="row my-3" v-if="req.status === 'expired'">
        <div class="col-12 col-md-4 mb-2">
          <label>وضعیت فعلی : </label>
          <span class="text-danger h6 font-weight-bold">منقضی شده</span>
        </div>
        <div class="col-12 col-md-4 mb-2">
          تاریخ انتقضا :
          <span class="h6 font-weight-bold">{{req.credit_date}}</span>
        </div>
        <div class="col-12 col-md-4 mb-2"></div>
      </div>
    </AjaxForm>
    <div v-if="error" class="alert alert-danger">{{error}}</div>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import {mapActions} from "vuex";
import AjaxForm from "@/components/forms/AjaxForm";
import {AppApi} from "@/api/AppApi";
import CustomInput from "@/components/CustomInput";
import {findSelectItem, showSystemNoti} from "@/shared/helper";
import Editor from '@tinymce/tinymce-vue'
export default {
  name: "RequestSpecialAccountEdit",
  props:['request_id'],
  components: {CustomInput, AjaxForm, Card,Editor},
  data()
  {
    return{
      status : null,
      req : null,
      error : null,
      id : this.$route.params.id,
      prefix : process.env.VUE_APP_API_URL+process.env.VUE_APP_USER_STORAGE,
      status_options : [
        {title : 'درانتظار بررسی',value : 'waiting'},
        {title : 'تایید شده',value : 'confirmed'},
        {title : 'رد شده',value : 'denied'},
      ]
    }
  },
  mounted()
  {
    if (!this.request_id)
    {
      this.setPageLoading(false);
      this.setPageTitle('ویرایش درخواست کاربر ویژه');
      this.setShowHead(true);
    }
    this.initPage();
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    async initPage()
    {
      this.setPageLoading(true);
      this.id = this.$route.params.id;
      if (!this.id)
        this.id = this.request_id;
      const result = await AppApi.getRequestSpecialAccountInfoForEdit(this.id);
      if (result.ok)
      {
        this.req = result.req;
        this.status = findSelectItem(this.req.status,this.status_options,'value')
      }
      else
          this.error = result.error;
      this.setPageLoading(false);
    },
    async editCallback(data)
    {
      if (data.ok)
      {
        return showSystemNoti('success',data.message,()=>{
          this.initPage();
        })
      }
      else
        return showSystemNoti('danger',data.error);
    }
  }
}
</script>

<style scoped>
.pic {
  display: block;
  width: 90px;
  height: 90px;
  object-fit: contain;
}
.pics-div
{
  display: flex;
  grid-column-gap: 15px;
}
.img-div {
  padding: 10px;
  border-radius: 13px;
  box-shadow: 0 0 5px 0 #0000008f;
  text-align: center;
  display: block;
  transition: all 200ms;
}
.img-div:hover
{
  box-shadow: 0 0 0 1px silver;
  transform: translateY(2px);
}
</style>